<template>
    <div class="hero" >
       
        <div class="hero-text"> 
      
            <h1>{{$t('hero-content-1')}}</h1>
            <h2>{{$t('hero-content-2')}} </h2>
            
           
            <a class='link1' href='#project'>{{$t('hero-content-4')}}</a>
           
           
        </div>
    </div> 
</template>

<script>

export default {
    name:"page-hero",

 
}
</script>


